import { createFileRoute, Outlet } from '@tanstack/react-router';
import ParkingCodebooks from '../../components/Codebooks/ParkingCodebooks';
import { PERMISSION_PARKING_TAG } from '../../Services/PermissionsService';
import { requirePermission } from '../../router/RouteGuardsService';

export const Route = createFileRoute('/_authenticated/system_settings/parking-tag')({
  beforeLoad: async ({ context }) => {
    await requirePermission(PERMISSION_PARKING_TAG, ['read'], '/unauthorized', context);
    return { ...context };
  },
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  component: ParkingTagLayout,
});

function ParkingTagLayout() {
  return (
    <>
      <ParkingCodebooks />
      <Outlet />
    </>
  );
}
